"use client";

import RichTextInput from "@/components/ui/RichTextInput";
import ProductSection from "./EditProductSection";
import { ProductClientState } from "@/zod/product.schema";
import { Controller, useFormContext } from "react-hook-form";

interface AboutSectionProps {
  currentLang: "en" | "fa";
  isOpen: boolean;
  onToggle: () => void;
}

export function AboutSection({
  currentLang,
  isOpen,
  onToggle,
}: AboutSectionProps) {
  const { control } = useFormContext<ProductClientState>();

  const dir = currentLang === "fa" ? "rtl" : "ltr";
  const editorAlign = currentLang === "fa" ? "text-right" : "text-left";

  return (
    <ProductSection
      title="About"
      faTitle="در یک نگاه"
      showFa={currentLang === "fa"}
      dir={dir}
      textAlign={currentLang === "fa" ? "justify" : "left"}
      open={isOpen}
      onToggle={onToggle}
      invalid={false}
    >
      <Controller
        key={currentLang}
        control={control}
        name={`about_${currentLang}`}
        defaultValue=""
        render={({ field }) => (
          <RichTextInput
            value={field.value ?? ""} // ✅ legacy HTML/text will still render
            onChange={({ json }) => field.onChange(JSON.stringify(json))} // ✅ always save JSON string
            placeholder={currentLang === "fa" ? "در یک نگاه" : "About"}
            className="bg-white rounded-md border border-gray-200"
            editorClassName={editorAlign}
            dir={dir}
            minHeightClassName="min-h-[6rem]"
          />
        )}
      />
    </ProductSection>
  );
}
